import * as React from 'react';
import questions from './questions.json';
import QuestionTemplate from './QuestionTemplate';

export default function Mold() {
  return (
    <div className="question-container">
      {Object.entries(questions.mold).map(([key, value], index) => (
        <QuestionTemplate
          key={key}
          identifier={key}
          type={value.type}
          label={value.label}
          event={'mold'}
        />
      ))}
    </div>
  );
}
